import React from 'react'
import './TopBar.css'

export default (props) => {
    return (
        <div className="topBar">{props.title}</div>
    )
}